import { 
  GETPRODUCTCURRENCY, 
  SET_SELECTED_CURRENCY, 
  CREATEPRODUCTCURRENCY, 
  DELETEPRODUCTCURRENCY 
} from "../actions/types";

const initialState = {
  currencyList: [],
  selectedCurrency: JSON.parse(localStorage .getItem('selectedCurrency')) || null,
  currencySaveStatus: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GETPRODUCTCURRENCY:
      return { ...state, currencyList: action.payload.data || [] };

    case CREATEPRODUCTCURRENCY:
      return { ...state, currencySaveStatus: action.payload.success };

    case SET_SELECTED_CURRENCY:
      return { ...state, selectedCurrency: action.payload };

    default:
      return state;
  }
}